import React, { useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getAllDebates } from '../../redux/Thunks/debatesThunk'
import DashTrendingDebates from './DashTrendingDebates'
import { toast } from 'react-toastify'
import { userDebatesFeed } from '../../redux/Selectors/selectors'
import { searchedFeedKeywords } from '../../redux/Slices/sharedUseEffectSlice'

function DebateFeed({whatToDisplay}) {

  const searchedKeywords = useSelector(searchedFeedKeywords)
  const dispatch = useDispatch()
  const [loadingStatus, setLoadingStatus] = useState(false)
  const [page, setPage] = useState(1)
  const [hasMore, setHasMore] = useState(true)
  const loaderRef = useRef(null)
  const fetchInProgress = useRef(false)

  const feed_directly_from_DB = useSelector(userDebatesFeed)
  const [trackedFeed, setTrackedFeed] = useState([])

  const feed = searchedKeywords ? feed_directly_from_DB?.results : trackedFeed


const fetchDebatesFeeds = async () => {

  if(fetchInProgress.current) return

  try {
    fetchInProgress.current = true
    setLoadingStatus(true);
    const {payload} = await dispatch(getAllDebates({
      page : page
    }))

    const result = Array.isArray(payload?.results) ? payload?.results : []

    setTrackedFeed((prevItems) => {
      const existingIds = new Set()
      prevItems.forEach(item => existingIds.add(item.debate_id))

      const uniqueNewItems = result.filter(item => {
        return !existingIds.has(item.debate_id)
      })

      return [...prevItems, ...uniqueNewItems]
    })


    if(searchedKeywords){
      setHasMore(feed_directly_from_DB?.next !== null);
      if (feed_directly_from_DB?.next) {
          setPage(prev => prev + 1);
      }
    }else{
      setHasMore(payload?.next !== null);
      if (payload?.next) {
          setPage(prev => prev + 1);
      }
    }


  } catch (error) {
    console.error('Failed to fetch debates:', error);
    toast.error('Failed to fetch debates, please refresh.')
  } finally {
    setLoadingStatus(false)
    fetchInProgress.current = false
  }
};


useEffect(() => {
},[searchedKeywords])

useEffect(() => {
    fetchDebatesFeeds()
  // eslint-disable-next-line
},[])


  // Intersection Observer effect
  useEffect(() => {
      const currentLoader = loaderRef.current;

      const observer = new IntersectionObserver(
          (entries) => {
              const target = entries[0];
              if (target.isIntersecting && hasMore && !loadingStatus && !fetchInProgress.current) {
                fetchDebatesFeeds();
              }
          },
          {
              root: null,
              rootMargin: '20px',
              threshold: 0.1
          }
      );

      if (currentLoader) {
          observer.observe(currentLoader);
      }

      return () => {
          if (currentLoader) {
              observer.unobserve(currentLoader);
          }
      };
      // eslint-disable-next-line
  }, [loadingStatus, hasMore]);



  return (
    <div className='pt-4'>
    <h1 className='hidden md:block mb-5 text-white font-nunito
    md:text-xl lg:text-[36px] not-italic font-bold leading-normal'>
    {whatToDisplay === "debates" && "Debates" }
    </h1>
    {loadingStatus
    ?
    <div className='flex item-center justify-center h-full w-full'>
    <div
    className="my-4 animate-spin rounded-full h-16 w-16
    border-t-4 border-[#3C6E71]"></div>
    </div>
    :

    (<div>
      {feed.length > 0 ?
        <div className={`h-[200vh] relative bg-nightModeDark_600 rounded-lg text-white overflow-y-scroll
     scroll-bar-in-dark pb-5`}>

     {feed?.map((item) => {
            return <div
        className='bg-[#101010] px-4 sm:px-5 my-3'
         key={item?.debate_id}>
        <DashTrendingDebates debaters={item} />
        </div>
     })}
    <div ref={loaderRef} className="h-10 flex items-center justify-center">
      {loadingStatus && <div className="text-white">Loading more...</div>}
    </div>

     </div>
     :

     <div className='flex item-center justify-center h-full w-full text-white '>
      <h3 className="font-bold text-xl my-8">No data</h3>
    </div>
        }
            </div>)

    }

    </div>
  )
}

export default DebateFeed
